/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Base ":host" styles for the component */
  box-sizing: border-box;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1);
}
:host * {
  box-sizing: border-box;
}

:host {
  position: relative;
  display: flex;
  inline-size: 100%;
  flex: 1 1 auto;
  align-items: stretch;
  overflow: hidden;
  background-color: transparent;
}
:host .frame {
  position: relative;
  margin: 0px;
  display: flex;
  inline-size: 100%;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: stretch;
  padding: 0px;
}
:host ::slotted(calcite-flow-item),
:host ::slotted(calcite-panel) {
  block-size: 100%;
}
:host ::slotted(.calcite-match-height:last-child) {
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
}
:host .frame--advancing {
  animation: calcite-frame-advance var(--calcite-animation-timing);
}
:host .frame--retreating {
  animation: calcite-frame-retreat var(--calcite-animation-timing);
}
@keyframes calcite-frame-advance {
  0% {
    --tw-bg-opacity: 0.5;
    transform: translate3d(50px, 0, 0);
  }
  100% {
    --tw-bg-opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes calcite-frame-retreat {
  0% {
    --tw-bg-opacity: 0.5;
    transform: translate3d(-50px, 0, 0);
  }
  100% {
    --tw-bg-opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}